<b-col cols="12" sm="12" md="4" lg="4" xl="4"></b-col>
<template>
    <b-modal title="Esecuzione Attivita" ref="mdlRsaAreaEsecuzioneEdit" id="mdlRsaAreaEsecuzioneEdit" size="lg" @ok="onOk">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Data Ora Esecuzione:</label>
                            <b-input-group class="mb-3">
                                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOraEffettuata" type="datetime"></date-picker>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Stato:</label>
                            <b-form-select :disabled="isStatoDisabled" id="inline-form-custom-select-pref" v-model="jsonData.stato" :value="null" value-field="value" text-field="text" class="mb-2 mr-sm-2 mb-sm-0" :options="statiOptions"></b-form-select>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <div>
                        <label class="sa-label-data">Note:</label>
                        <b-form-textarea id="textarea-no-resize" v-model="jsonData.note" rows="7" no-resize></b-form-textarea>
                    </div>
                    <div>
                        <label class="sa-label-data">Indicazioni:</label>
                        <span v-html="jsonData.indicazioni"></span>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
// import { VueEditor } from "vue2-editor";
export default {
    components: {
        DatePicker,
        // VueEditor,
    },
    data() {
        return {
            isStatoDisabled: false,
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            pathResource: "/rsaattivitapazienti/slot",
            jsonData: { stato: null },
            statiOptions: [
                { value: null, text: "-Seleziona Stato-" },
                { value: "ESEGUITA", text: "ESEGUITA" },
                { value: "NON ESEGUITA", text: "NON ESEGUITA" },
            ],
            perPage: 1000000,
        };
    },
    methods: {
        add(jsonData, stato = null) {
            let me = this;
            me.isStatoDisabled = stato == "NON ESEGUITA" ? true : false;

            me.jsonData = Object.assign({}, jsonData);
            me.jsonData.stato = stato;
            me.jsonData.note = "";
            me.$refs.mdlRsaAreaEsecuzioneEdit.show();
        },
        onChangeAttivita() {},
        onOk(bvModalEvent) {
            let me = this;
            if (me.jsonData.stato) {
                if (me.jsonData.stato === "NON ESEGUITA" && me.jsonData.note.trim() === "") {
                    me.$bvModal
                        .msgBoxOk("Le NOTE sono obbligatorie per lo stato NON ESEGUITO", {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                } else {
                    me.eseguiAttivita();
                }
            } else {
                me.$bvModal
                    .msgBoxOk("Selezionare lo stato", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerBgVariant: "danger",
                        centered: true,
                    })
                    .then(() => {})
                    .catch((err) => {
                        console.log(err);
                    });
            }
            //me.eseguiAttivita();
            bvModalEvent.preventDefault();
        },
        eseguiAttivita() {
            let me = this;
            if (me.jsonData.rsaAttivitaPazienteBean === null) {
                // console.log("POST");

                me.creaAttivita();
            } else {
                // console.log("PUT");
                me.aggiornaAttivita();
            }
        },
        creaAttivita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .post(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaEsecuzioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        aggiornaAttivita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.rsaAttivitaPazienteBean.id;
            axios
                .put(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                    me.$refs.mdlRsaAreaEsecuzioneEdit.hide();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerBgVariant: "danger",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
    },
};
</script>

<style>
.sa-flexbox-body .row {
    flex: 1;
    height: 1px;
}

.sa-flexbox-body .row .col-sm-12.col-md-12.col-lg-12.col-xl-12.col-12 {
    height: 100%;
}
</style>
